import {
    ADD_ORDER_START,
    ADD_ORDER_SUCCESS,
    ADD_ORDER_ERROR
} from '../../constants';
import showToaster from "../../helpers/toastrMessgaes/showToaster"
import { setLoaderComplete, setLoaderStart } from '../loader/loader';
import { addOrderWhole as mutation } from '../../lib/graphql';
import history from '../../history';


export function addOrderAction(ordersData) {
    return async (dispatch, getState, { client }) => {
        try {
            if (!navigator.onLine) {
                showToaster({ messageId: 'networkFailed', toasterType: 'error' })
                return;
            }
            dispatch({
                type: ADD_ORDER_START,
            });
            dispatch(setLoaderStart('orderLoading'));
            const cartList = ordersData?.length > 0 && JSON.stringify(ordersData)
            const { data } = await client.mutate({
                mutation,
                variables: {
                    cartList
                }
            })
            if (data?.addOrderWhole?.status === 200) {
                dispatch(setLoaderComplete('orderLoading'));
                history.push(`/order/${data?.addOrderWhole?.result?.id}`);
                dispatch({
                    type: ADD_ORDER_SUCCESS,
                });
            } else {
                dispatch(setLoaderComplete('orderLoading'));
                let errorMessage = data?.addOrderWhole?.errorMessage
                await showToaster({ messageId: 'errorMessage', toasterType: 'error', requestContent: errorMessage })
                dispatch({ type: ADD_ORDER_ERROR });
            }
        } catch (error) {
            dispatch({
                type: ADD_ORDER_ERROR,
                payload: {
                    error,
                },
            });
            return false;
        }
        return true;
    };
}



